/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Representation of a request of replacing an existing user's login id.
 * @export
 * @interface ReplaceLoginIdInput
 */
export interface ReplaceLoginIdInput {
    /**
     * New login id that is a unique string to identify a user.
     * @type {string}
     * @memberof ReplaceLoginIdInput
     */
    newLoginId: string;
    /**
     * User password
     * @type {string}
     * @memberof ReplaceLoginIdInput
     */
    password: string;
}

/**
 * Check if a given object implements the ReplaceLoginIdInput interface.
 */
export function instanceOfReplaceLoginIdInput(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "newLoginId" in value;
    isInstance = isInstance && "password" in value;

    return isInstance;
}

export function ReplaceLoginIdInputFromJSON(json: any): ReplaceLoginIdInput {
    return ReplaceLoginIdInputFromJSONTyped(json, false);
}

export function ReplaceLoginIdInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReplaceLoginIdInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'newLoginId': json['newLoginId'],
        'password': json['password'],
    };
}

export function ReplaceLoginIdInputToJSON(value?: ReplaceLoginIdInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'newLoginId': value.newLoginId,
        'password': value.password,
    };
}

